module.exports = __webpack_public_path__ + "img/22_1.6195e478.png";